module.exports = __webpack_public_path__ + "static-portal/img/new8-3.cf76af0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new8-3.png
// module id = 817e
// module chunks = 4